import { Inject, Injectable } from '@angular/core';
import { WA_WINDOW } from '@ng-web-apis/common';
import { Environment } from '@rma/generic/util/environment';

@Injectable({
  providedIn: 'root',
})
export class SocialMediaShareLinkService {
  private readonly facebookShareUrl = 'https://www.facebook.com/sharer/sharer.php?u={shareUrl}&display=popup&ref=plugin';
  private readonly twitterShareUrl = 'https://twitter.com/share?url={shareUrl}';
  private readonly linkedInShareUrl = 'https://www.linkedin.com/cws/share?url={shareUrl}';

  constructor(
    private readonly environment: Environment,
    @Inject(WA_WINDOW) readonly windowRef: Window,
  ) {}

  public shareOnFacebook(url?: string): void {
    this.share(this.facebookShareUrl, url);
  }

  public shareOnTwitter(url?: string): void {
    this.share(this.twitterShareUrl, url);
  }

  public shareOnLinkedin(url?: string): void {
    this.share(this.linkedInShareUrl, url);
  }

  private share(providerUrl: string, shareUrl?: string): void {
    if (!this.windowRef) {
      return;
    }

    if (!shareUrl) {
      shareUrl = this.windowRef.location.href;
    } else if (!shareUrl.startsWith('http') && !shareUrl.startsWith('www')) {
      let baseUrl = this.environment.baseUrl.trim();
      if (!baseUrl.endsWith('/')) {
        baseUrl += '/';
      }
      shareUrl = `${baseUrl}${shareUrl}`;
    }

    this.windowRef.open(providerUrl.replace('{shareUrl}', shareUrl), 'sharer', 'toolbar=0,status=0,width=626,height=436');
  }
}
